import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthClienteService } from '../services/authCliente.service';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class LoginClienteGuard implements CanActivate, CanActivateChild {
  constructor(private auth: AuthClienteService, private router: Router, private route: ActivatedRoute,    private storage: StorageService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      let user = this.auth.getUser();
      if (this.auth.isLoggedIn()) {
        this.router.navigateByUrl('/');
        return false;
      } else {
        let listUrl = window.location.href.split('/login/');
        if(listUrl.length>1) {
        this.storage.saveToken(listUrl[1]);}
        return true;
      }
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      let user = this.auth.getUser();
      if (this.auth.isLoggedIn()) {
        this.router.navigateByUrl('/login')
        return false;
      } else {
        return true;
      }
  }
}
